import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { ClickEventListener } from '@philips-emr/tws-core/lib/component/types';

export default class HpmsReportListAPI extends ComponentAPI<any> {
  @AwesomeEvent
  onClick = new ClickEventListener();

  setData(data: any[]): void {
    this.setState({ data });
  }

  setLoading(value: boolean): void {
    this.setState({ loading: value });
  }
}
